<template>
    <div class="admin-page-content-in admin-page-promocodes">
        <div class="container">
            <div class="page-title">
                <h1>Промокоды</h1>
                <div class="user-name-title">
                    <span>Вы авторизованы как:</span>
                    <strong>{{adminData.user.email}}</strong>
                </div>
            </div>
            <div class="user-container">
                <div class="user-search">
                    <form class="search-form-in" @submit.prevent="searchCode">
                        <div class="form-group">
                            <!-- <input type="text" name="userID" v-model="s_codeID" placeholder="Введите промокод - ########" class="form-control" v-validate="{ required: true }" data-vv-delay="1000"> -->
                            <masked-input v-model="s_codeID" mask="########" placeholder="Введите промокод" autocomplete="off" class="form-control" name="code" v-validate="{ required: true, regex: regexRules.code }" data-vv-delay="1000" :class="{'erorr-input' : errors.has('code')}"/>

                            <!-- <span class="error-message" v-show="errors.has('userID')" :class="{visible: errors.has('userID')}">Введите ID пользователя</span> -->
                        </div>
                        <div class="form-btn">
                            <button class="btn-login" @click.prevent="searchCode" :disabled="errors.any()">
                                <span>Найти</span>
                            </button>
                        </div>
                    </form>
                </div>
                <div class="user-result">
                    <!-- {{ codeResultArr }} -->
                    <div class="user-item" v-if="codeResultArr != null">
                        <h4>Данные промокода:</h4>
                        <ul>
                            <li><span>Code</span><strong>{{ codeResultArr.code }}</strong></li>
                            <li><span>User ID</span><strong>{{ codeResultArr.userID }}</strong></li>
                            <li><span>Дата активации</span><strong>{{ codeResultArr.activate_date }}</strong></li>
                        </ul>
                    </div>
                    <div class="clear-title" v-if="codeResultArr == null && !errorMsg"><strong>Результат поиска</strong></div>
                    <div class="notfound-msg" v-if="errorMsg"><p>Такой промокод не найден</p></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import { doc, getDoc } from "firebase/firestore";
    import MaskedInput from 'vue-masked-input'
    export default {
        name: 'admin--page-promocodes',
        components: {
            MaskedInput,
            // svgIcon,
        },
        data () {
            return {
                errorMsg: false,
                codeResultArr: null,
                s_codeID: null,
                regexRules: {
                    code: /^[A-Z0-9]{8}$/,
                }
            }
        },
        computed: mapGetters({
            adminData: 'loadAdminDataStore',
        }),
        methods: {
            searchCode() {
                this.$validator.validate().then(async result => {
                    if(result) {
                        // console.log(true, 'searchForm Code', this.s_codeID);
                        const codeID = this.s_codeID.replace(/-/g, '');
                        const codeRef = doc(this.$db, "codes", codeID);
                        const codeSnap = await getDoc(codeRef);
                        if (codeSnap.exists()) {
                            this.errorMsg = false;
                            this.codeResultArr = codeSnap.data();
                            console.log("Code data:", codeSnap.data());
                        } else {
                            this.errorMsg = true;
                            // docSnap.data() will be undefined in this case
                            console.log("No such code!");
                        }
                    } else {
                        console.log('Form code with errors');
                    }
                });
            }
        },
        // beforeRouteEnter (to, from, next) {
        //     const adminLocalState = localStorage.getItem('adminArrData');
        //     if (adminLocalState == null) {
        //         next('/admin/auth')
        //     } else {
        //         next();
        //     }
        // },
        beforeCreate() {
            document.body.dataset.page = 'admin-page-users';
        },
        created () {
        },
        mounted() {
        }
    }
</script>


<style lang="scss">
    @import '@/styles/components/admin/admin-page.scss';
    @import '@/styles/components/admin/admin-promocodes.scss';
</style>